import { AddAccountRouterComponent } from '@popup/steem/pages/add-account/add-account-router/add-account-router.component';
import { AddByAuthComponent } from '@popup/steem/pages/add-account/add-by-auth/add-by-auth.component';
import { AddByKeysComponent } from '@popup/steem/pages/add-account/add-by-keys/add-by-keys.component';
import { ImportKeysComponent } from '@popup/steem/pages/add-account/import-keys/import-keys.component';
import { SelectKeysComponent } from '@popup/steem/pages/add-account/select-keys/select-keys.component';
import { BuyCoinsComponent } from '@popup/steem/pages/app-container/home/buy-coins/buy-coins.component';
import { ConversionComponent } from '@popup/steem/pages/app-container/home/conversion/conversion.component';
import { PendingConersionPageComponent } from '@popup/steem/pages/app-container/home/conversion/pending-conversion/pending-conversion.component';
import { DelegationsComponent } from '@popup/steem/pages/app-container/home/delegations/delegations.component';
import { IncomingOutgoingPageComponent } from '@popup/steem/pages/app-container/home/delegations/incoming-outgoing-page/incoming-outgoing-page.component';
import { GovernanceComponent } from '@popup/steem/pages/app-container/home/governance/governance.component';
import { HomeComponent } from '@popup/steem/pages/app-container/home/home.component';
import HistoryPage from '@popup/steem/pages/app-container/home/history/HistoryPage';
import { PowerUpDownComponent } from '@popup/steem/pages/app-container/home/power-up-down/power-up-down.component';
import { PendingSavingsWithdrawalPageComponent } from '@popup/steem/pages/app-container/home/savings/pending-savings-withdrawal/pending-savings-withdrawal-page.component';
import { SavingsPageComponent } from '@popup/steem/pages/app-container/home/savings/savings.component';
import { TokenSwapsHistoryComponent } from '@popup/steem/pages/app-container/home/swaps/token-swaps-history/token-swaps-history.component';
import { TokenSwapsComponent } from '@popup/steem/pages/app-container/home/swaps/token-swaps/token-swaps.component';
import { TokenIncomingOutgoingPageComponent } from '@popup/steem/pages/app-container/home/tokens/token-delegations/token-incoming-outgoing-page/token-incoming-outgoing-page.component';
import { TokensOperationComponent } from '@popup/steem/pages/app-container/home/tokens/token-operation/token-operation.component';
import { TokenPendingUnstakePage } from '@popup/steem/pages/app-container/home/tokens/token-pending-unstacking/token-pending-unstacking.component';
import { TokensFilterComponent } from '@popup/steem/pages/app-container/home/tokens/tokens-filter/tokens-filter.component';
import { TokensHistoryComponent } from '@popup/steem/pages/app-container/home/tokens/tokens-history/tokens-history.component';
import { TokensTransferComponent } from '@popup/steem/pages/app-container/home/tokens/tokens-transfer/tokens-transfer.component';
import { TransferFundsComponent } from '@popup/steem/pages/app-container/home/transfer-fund/transfer-fund.component';
import { WalletHistoryComponent } from '@popup/steem/pages/app-container/home/wallet-history/wallet-history.component';
import { AboutPageComponent } from '@popup/steem/pages/app-container/settings/about/about.component';
import { AccountSubMenuComponent } from '@popup/steem/pages/app-container/settings/accounts/account-sub-menu.component';
import { CreateAccountStepOneComponent } from '@popup/steem/pages/app-container/settings/accounts/create-account/create-account-step-one/create-account-step-one.component';
import { CreateAccountStepTwoComponent } from '@popup/steem/pages/app-container/settings/accounts/create-account/create-account-step-two/create-account-step-two.component';
import { ManageAccountAuthoritiesComponent } from '@popup/steem/pages/app-container/settings/accounts/manage-account-authorities/manage-account-authorities.component';
import { AddKeyComponent } from '@popup/steem/pages/app-container/settings/accounts/manage-account/add-key/add-key.component';
import { ManageAccountComponent } from '@popup/steem/pages/app-container/settings/accounts/manage-account/manage-account.component';
import { AdvancedSettingsPageComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/advanced-settings.component';
import { AnalyticsComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/analytics/analytics.component';
import { AutoLockComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/auto-lock/auto-lock.component';
import { ChangePasswordComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/change-password/change-password.component';
import { ClearAllDataComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/clear-all-data/clear-all-data.component';
import { ImportExportPreferencesComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/import-export-preferences/import-export-preferences.component';
import { KeychainifyComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/keychainify/keychainify.component';
import { RpcNodesComponent } from '@popup/steem/pages/app-container/settings/advanced-settings/rpc-nodes/rpc-nodes.component';
import { HelpSubMenuComponent } from '@popup/steem/pages/app-container/settings/help-sub-menu/help-sub-menu.component';
import { SettingsMainPageComponent } from '@popup/steem/pages/app-container/settings/settings-main-page/settings-main-page.component';
import { AuthorizedOperationsComponent } from '@popup/steem/pages/app-container/settings/user-preferences/authorized-operations/authorized-operations.component';
import { AutomatedTasksComponent } from '@popup/steem/pages/app-container/settings/user-preferences/automated-tasks/automated-tasks.component';
import { ExportTransactionsComponent } from '@popup/steem/pages/app-container/settings/user-preferences/export-transactions/export-transactions.component';
import { FavoriteAccountsComponent } from '@popup/steem/pages/app-container/settings/user-preferences/favorite-accounts/favorite-accounts.component';
import { MultisigComponent } from '@popup/steem/pages/app-container/settings/user-preferences/multisig/multisig.component';
import { NotificationsConfigComponent } from '@popup/steem/pages/app-container/settings/user-preferences/notifications/notifications-config/notifications-config.component';
import { OperationPopupComponent } from '@popup/steem/pages/app-container/settings/user-preferences/operation-popup/operation-popup.component';
import { UserPreferencesPageComponent } from '@popup/steem/pages/app-container/settings/user-preferences/user-preferences.component';
import React from 'react';
import { connect } from 'react-redux';
import { ConfirmationPageComponent } from 'src/common-ui/confirmation-page/confirmation-page.component';
import { PageTitleComponent } from 'src/common-ui/page-title/page-title.component';
import { Screen } from 'src/reference-data/screen.enum';
const AppRouter = ({ currentPage, titleProperties, hasTitle, }) => {
    const renderAccountPage = (page) => {
        // console.log('[TEST] Rendering page:', page); // Aggiunto per debug
        switch (page) {
            case Screen.HOME_PAGE:
                return React.createElement(HomeComponent, null);
            case Screen.GOVERNANCE_PAGE:
                return React.createElement(GovernanceComponent, null);
            case Screen.TRANSFER_FUND_PAGE:
                return React.createElement(TransferFundsComponent, null);
            case Screen.POWER_UP_PAGE:
                return React.createElement(PowerUpDownComponent, null);
            case Screen.POWER_DOWN_PAGE:
                return React.createElement(PowerUpDownComponent, null);
            case Screen.BUY_COINS_PAGE:
                return React.createElement(BuyCoinsComponent, null);
            case Screen.WALLET_HISTORY_PAGE:
                return React.createElement(WalletHistoryComponent, null);
            case Screen.CONFIRMATION_PAGE:
                return React.createElement(ConfirmationPageComponent, null);
            case Screen.CONVERSION_PAGE:
                return React.createElement(ConversionComponent, null);
            case Screen.PENDING_CONVERSION_PAGE:
                return React.createElement(PendingConersionPageComponent, null);
            case Screen.SAVINGS_PAGE:
                return React.createElement(SavingsPageComponent, null);
            case Screen.PENDING_SAVINGS_WITHDRAWAL_PAGE:
                return React.createElement(PendingSavingsWithdrawalPageComponent, null);
            case Screen.DELEGATION_PAGE:
                return React.createElement(DelegationsComponent, null);
            case Screen.INCOMING_OUTGOING_PAGE:
                return React.createElement(IncomingOutgoingPageComponent, null);
            //Tokens
            case Screen.TOKENS_HISTORY:
                return React.createElement(TokensHistoryComponent, null);
            case Screen.TOKENS_TRANSFER:
                return React.createElement(TokensTransferComponent, null);
            case Screen.TOKENS_OPERATION:
                return React.createElement(TokensOperationComponent, null);
            case Screen.TOKENS_DELEGATIONS:
                return React.createElement(TokenIncomingOutgoingPageComponent, null);
            case Screen.TOKENS_FILTER:
                return React.createElement(TokensFilterComponent, null);
            case Screen.TOKEN_SWAP_PAGE:
                return React.createElement(TokenSwapsComponent, null);
            case Screen.TOKENS_SWAP_HISTORY:
                return React.createElement(TokenSwapsHistoryComponent, null);
            case Screen.TOKENS_PENDING_UNSTAKE:
                return React.createElement(TokenPendingUnstakePage, null);
            //History
            case Screen.HISTORY_PAGE:
                return React.createElement(HistoryPage, null); // Aggiunto
            //Settings Routes
            case Screen.SETTINGS_MAIN_PAGE:
                return React.createElement(SettingsMainPageComponent, null);
            case Screen.SETTINGS_ACCOUNTS:
                return React.createElement(AccountSubMenuComponent, null);
            case Screen.ACCOUNT_PAGE_INIT_ACCOUNT:
                return React.createElement(AddAccountRouterComponent, null);
            case Screen.ACCOUNT_PAGE_ADD_BY_KEYS:
                return React.createElement(AddByKeysComponent, null);
            case Screen.ACCOUNT_PAGE_ADD_BY_AUTH:
                return React.createElement(AddByAuthComponent, null);
            case Screen.ACCOUNT_PAGE_IMPORT_KEYS:
                return React.createElement(ImportKeysComponent, null);
            case Screen.ACCOUNT_PAGE_SELECT_KEYS:
                return React.createElement(SelectKeysComponent, null);
            case Screen.SETTINGS_MANAGE_ACCOUNTS:
                return React.createElement(ManageAccountComponent, null);
            case Screen.SETTINGS_MANAGE_ACCOUNTS_AUTHORITIES:
                return React.createElement(ManageAccountAuthoritiesComponent, null);
            case Screen.SETTINGS_ADD_KEY:
                return React.createElement(AddKeyComponent, null);
            case Screen.SETTINGS_ADVANCED:
                return React.createElement(AdvancedSettingsPageComponent, null);
            case Screen.SETTINGS_CHANGE_PASSWORD:
                return React.createElement(ChangePasswordComponent, null);
            case Screen.SETTINGS_RPC_NODES:
                return React.createElement(RpcNodesComponent, null);
            case Screen.SETTINGS_AUTO_LOCK:
                return React.createElement(AutoLockComponent, null);
            case Screen.SETTINGS_KEYCHAINIFY:
                return React.createElement(KeychainifyComponent, null);
            case Screen.SETTINGS_CLEAR_ALL_DATA:
                return React.createElement(ClearAllDataComponent, null);
            case Screen.SETTINGS_IMPORT_EXPORT:
                return React.createElement(ImportExportPreferencesComponent, null);
            case Screen.SETTINGS_USER_PREFERENCES:
                return React.createElement(UserPreferencesPageComponent, null);
            case Screen.SETTINGS_AUTHORIZED_OPERATIONS:
                return React.createElement(AuthorizedOperationsComponent, null);
            case Screen.SETTINGS_EXPORT_TRANSACTIONS:
                return React.createElement(ExportTransactionsComponent, null);
            case Screen.SETTINGS_OPERATION_POPUP:
                return React.createElement(OperationPopupComponent, null);
            case Screen.SETTINGS_AUTOMATED_TASKS:
                return React.createElement(AutomatedTasksComponent, null);
            case Screen.SETTINGS_FAVORITE_ACCOUNTS:
                return React.createElement(FavoriteAccountsComponent, null);
            case Screen.SETTINGS_NOTIFICATIONS_CONFIGURATION:
                return React.createElement(NotificationsConfigComponent, null);
            case Screen.SETTINGS_MULTISIG:
                return React.createElement(MultisigComponent, null);
            case Screen.SETTINGS_ABOUT:
                return React.createElement(AboutPageComponent, null);
            case Screen.SETTINGS_HELP:
                return React.createElement(HelpSubMenuComponent, null);
            case Screen.CREATE_ACCOUNT_PAGE_STEP_ONE:
                return React.createElement(CreateAccountStepOneComponent, null);
            case Screen.CREATE_ACCOUNT_PAGE_STEP_TWO:
                return React.createElement(CreateAccountStepTwoComponent, null);
            case Screen.SETTINGS_ANALYTICS:
                return React.createElement(AnalyticsComponent, null);
            default:
                return null;
        }
    };
    return (React.createElement("div", { className: "app-router", style: {
            height: '100%',
            display: 'grid',
            gridTemplateRows: hasTitle ? '80px 1fr' : '1fr',
        } },
        hasTitle && (React.createElement(PageTitleComponent, Object.assign({}, titleProperties))),
        React.createElement("div", { className: "page-content", style: {
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
            } }, renderAccountPage(currentPage))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        currentPage: state.navigation.stack[0]
            ? state.navigation.stack[0].currentPage
            : Screen.UNDEFINED,
        hasTitle: ((_a = state.titleContainer) === null || _a === void 0 ? void 0 : _a.title.length) > 0,
        titleProperties: state.titleContainer,
    };
};
const connector = connect(mapStateToProps, {});
export const AppRouterComponent = connector(AppRouter);
